export default "__VITE_ASSET__CkDDjuuB__"